<template>
  <vue-apex-charts
    type="bar"
    height="280"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

const formatChartLabel = (value) => {
  const number = Number(value)
  if (!Number.isFinite(number)) return ''
  return new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 2,
  }).format(number)
}

const chartColors = () => {
  const dark = document.body.classList.contains('dark-layout')
  return {
    label: dark ? '#b4b7bd' : '#6e6b7b',
    grid: dark ? 'rgba(255, 255, 255, 0.08)' : '#ebe9f1',
  }
}

export default {
  components: {
    VueApexCharts,
  },
  props: {
    title: { type: String, default: '' },
    axisX: {
      type: Array,
      required: true,
    },
    axisY: {
      type: Array,
      required: true,
    },
    unit: {
      type: String,
      default: '',
    },
  },
  computed: {
    series() {
      return [{
        name: this.title || this.unit,
        data: this.axisY.map(value => Number(value) || 0),
      }]
    },
    chartOptions() {
      const colors = chartColors()
      const unit = this.unit
      return {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          fontFamily: 'Montserrat, Helvetica, Arial, serif',
          parentHeightOffset: 0,
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 450,
          },
        },
        colors: ['#7367f0'],
        plotOptions: {
          bar: {
            borderRadius: 6,
            borderRadiusApplication: 'end',
            columnWidth: '58%',
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.15,
            opacityFrom: 1,
            opacityTo: 0.82,
            stops: [0, 100],
          },
        },
        dataLabels: { enabled: false },
        stroke: { show: false, width: 0 },
        grid: {
          borderColor: colors.grid,
          strokeDashArray: 4,
          padding: { left: 8, right: 12, top: 0, bottom: 0 },
        },
        legend: { show: false },
        xaxis: {
          categories: this.axisX,
          axisBorder: { show: false },
          axisTicks: { show: false },
          tooltip: { enabled: false },
          labels: {
            rotate: -40,
            rotateAlways: this.axisX.length > 12,
            hideOverlappingLabels: true,
            style: {
              colors: colors.label,
              fontSize: '11px',
              fontWeight: 500,
            },
          },
        },
        yaxis: {
          decimalsInFloat: 2,
          labels: {
            formatter: formatChartLabel,
            style: {
              colors: colors.label,
              fontSize: '11px',
            },
          },
          ...(unit ? {
            title: {
              text: unit,
              style: {
                color: colors.label,
                fontSize: '12px',
                fontWeight: 600,
              },
            },
          } : {}),
        },
        tooltip: {
          shared: false,
          intersect: true,
          y: {
            formatter: value => {
              const formatted = formatChartLabel(value)
              return unit ? `${formatted} ${unit}` : formatted
            },
          },
        },
        states: {
          hover: { filter: { type: 'lighten', value: 0.08 } },
          active: { filter: { type: 'none' } },
        },
        noData: {
          text: this.$t('No data found'),
          style: { color: colors.label, fontSize: '14px' },
        },
      }
    },
  },
}
</script>
